import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import INavItem from "../../../models/INavItem";
import IUserUI from "../../../models/IUserUI";
import IConnection_Token from "../../../models/IConnection_Token";
import { SideNavLink } from "../../shared/SideNavLink/SideNavLink";
import "./DraggableNavItem.scss";

type Props = {
    id: string;
    navItem: INavItem;
    user: IUserUI;
    isSupplierUser: boolean;
    supplierUserToken?: IConnection_Token;
    vendorUserToken?: IConnection_Token;
    menuIconMode: boolean;
};

export const DraggableNavItem: React.FC<Props> = (props) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
    };

    return (
        <div ref={setNodeRef} style={style} className="draggable-nav-item">
            <div className="d-flex align-items-center">
                <div {...attributes} {...listeners} className="drag-handle p-2" style={{ cursor: "grab", left: "5px" }}>
                    <i className="fas fa-grip-vertical text-muted" />
                </div>
                <div className="d-flex flex-column flex-grow-1">
                    <SideNavLink
                        user={props.user}
                        isSupplierUser={props.isSupplierUser}
                        supplierUserToken={props.supplierUserToken}
                        vendorUserToken={props.vendorUserToken}
                        navItem={props.navItem}
                        navigated={() => {}}
                        menuIconMode={props.menuIconMode}
                    />
                </div>
            </div>
        </div>
    );
};
